
import Header from "../../header";
import Footer from "../../footer";
import ContactForm from "../../contactcomponents/contactform";
import BannerFooter from "../productpages/bannerForFooter";
import productassistanceimage from '../../../images/footerLinksImages/support/productassistance.png'
function ProductAssistance() {

    const keywords = [
        { title: "Product Overview", summary: "Get a comprehensive overview of our product's features, benefits, and functionality to understand its value better." },
        { title: "User Guide", summary: "Step-by-step instructions on how to use the product, from installation to advanced functionalities." },
        { title: "Troubleshooting Tips", summary: "Solve common issues that may arise with the product through detailed troubleshooting guidance." },
        { title: "FAQ", summary: "Find answers to frequently asked questions about the product, including setup, features, and maintenance." },
        { title: "Product Warranty", summary: "Learn about the product's warranty coverage, terms, and how to claim warranty services." },
        { title: "Installation Support", summary: "Access helpful information to guide you through the installation process and make setup seamless." },
        { title: "Customer Support", summary: "Reach out to our dedicated support team for any product-related questions or concerns." },
        { title: "Software Updates", summary: "Stay updated on the latest software improvements and how to apply updates to your product." },
        { title: "Product Return Process", summary: "Understand the steps involved in returning the product, including policies and eligibility." },
        { title: "Product Compatibility", summary: "Check compatibility information to ensure the product works seamlessly with your existing systems and devices." },
      ];
      
    return (<>
        <Header />
       
        <BannerFooter
            title="Product Assistance"
            text="Product Assistance focuses on helping customers make the most of the products they purchase. It involves providing guidance on proper usage, addressing any issues that arise, offering troubleshooting tips, and assisting with product maintenance and upgrades. Product Assistance services also include helping customers with product installation, providing instructional materials, and assisting with warranty claims or returns. With expert support available at every stage of the product lifecycle, customers can enhance their experience, ensuring they get the most value from their investment while minimizing any disruptions caused by product-related challenges."
            imageone={productassistanceimage}
            imagetwo={productassistanceimage}
        />

<div className="container-fluid py-5 bg-light">
  <div className="container p-4 shadow-lg bg-white rounded">
    <h2 className="text-center mb-4">Product Assistance</h2>
    <div className="accordion" id="productAssistanceAccordion">
      {keywords.map((item, index) => (
        <div className="accordion-item" key={index}>
          <h2 className="accordion-header" id={`heading-${index}`}>
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target={`#collapse-${index}`}
              aria-expanded="false"
              aria-controls={`collapse-${index}`}
              style={{ transition: "all 0.3s ease" }}
            >
              {item.title}
            </button>
          </h2>
          <div
            id={`collapse-${index}`}
            className="accordion-collapse collapse"
            aria-labelledby={`heading-${index}`}
            data-bs-parent="#productAssistanceAccordion"
          >
            <div className="accordion-body">
              {item.summary}
            </div>
          </div>
        </div>
      ))}
    </div>
  </div>
</div>

        <ContactForm />
        <Footer />
    </>)
}

export default ProductAssistance